import { createFileRoute } from '@tanstack/react-router'

import { McpSetupPage } from '#features/integrations/mcp-setup/mcp-setup-page'

export const Route = createFileRoute(
  '/_app/$workspace/settings/integrations/mcp-setup',
)({
  head: () => ({
    meta: [
      {
        title: 'MCP setup',
      },
    ],
  }),
  component: () => <McpSetupPage />,
})
